import { useState, useEffect, useRef } from "react";
import { isEmpty, first, drop, get } from "lodash";
import Image from "grandus-lib/components-atomic/image/Image";

import { generateGalleryImageObject } from "components/gallery/Gallery";

import styles from "./Gallery.module.scss";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

let scrollEndPosition = null;

const MobileGallery = ({
  images,
  titleImage = null,
  showThumbnails = false,
  options = {},
}) => {
  const galleryScrollRef = useRef();
  const [leftArrowVisibility, setLeftArrowsVisibility] = useState(false);
  const [rightArrowVisibility, setRightArrowsVisibility] = useState(true);
  if (isEmpty(images) && titleImage == null) {
    return null;
  }

  let photos = images.map((image) => generateGalleryImageObject(image));
  let mainPhoto = generateGalleryImageObject(titleImage);
  if (!mainPhoto) {
    mainPhoto = first(photos);
    photos = drop(photos, 1);
  }

  useEffect(() => {
    if (galleryScrollRef.current) {
      scrollEndPosition =
        galleryScrollRef.current.scrollWidth -
        galleryScrollRef.current.offsetWidth; // full width - "first image" width
    }
  }, [galleryScrollRef]);

  const handleScroll = (e) => {
    e.preventDefault();
    if (galleryScrollRef.current.scrollLeft > 0) {
      setLeftArrowsVisibility(true);
    } else {
      setLeftArrowsVisibility(false);
    }

    if (galleryScrollRef.current.scrollLeft >= scrollEndPosition) {
      setRightArrowsVisibility(false);
    } else {
      setRightArrowsVisibility(true);
    }
  };

  const onRightClick = (e) => {
    if (galleryScrollRef.current.scrollLeft < scrollEndPosition) {
      galleryScrollRef.current.scrollLeft += 50;
    }
  };

  const onLeftClick = (e) => {
    if (galleryScrollRef.current.scrollLeft > 0) {
      galleryScrollRef.current.scrollLeft -= 50;
    }
  };

  return (
    <>
      {leftArrowVisibility ? (
        <LeftOutlined
          className={`${styles?.arrow} ${styles?.left}`}
          onMouseDown={onLeftClick}
          onTouchStart={onLeftClick}
        />
      ) : null}

      <div
        className={styles?.gallery}
        ref={galleryScrollRef}
        onScroll={handleScroll}
      >
        <span className={styles?.mainImage}>
          <Image
            photo={mainPhoto}
            size={"600x500__cropped"}
            type={"jpg"}
            {...get(options, "imageMainProps", {})}
          />
        </span>
        {showThumbnails && !isEmpty(photos) ? (
          <div className={styles?.thumbnails}>
            {photos.map((photo, index) => (
              <span key={`thumbnail-${index}`}>
                <Image
                  photo={photo}
                  size={"100x100__cropped"}
                  type={"jpg"}
                  {...get(options, "imageThumbnailProps", {})}
                />
              </span>
            ))}
          </div>
        ) : null}
      </div>
      {rightArrowVisibility ? (
        <RightOutlined
          className={`${styles?.arrow} ${styles?.right}`}
          onMouseDown={onRightClick}
          onTouchStart={onRightClick}
        />
      ) : null}
    </>
  );
};

export default MobileGallery;
